import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityLayout,
  EntityLinksCard,
} from '@backstage/plugin-catalog';
import {
  EntityApiDefinitionCard,
  EntityConsumingComponentsCard,
  EntityProvidingComponentsCard,
} from '@backstage/plugin-api-docs';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { entityWarningContent } from '../shared/tabs';

export const apiPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Resumo">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item md={6}><EntityAboutCard /></Grid>
        <Grid item md={6} xs={12}><EntityCatalogGraphCard variant="gridItem" height={400} /></Grid>
        <Grid item md={4} xs={12}><EntityLinksCard /></Grid>
        <Grid container item md={12}>
          <Grid item md={6}><EntityProvidingComponentsCard /></Grid>
          <Grid item md={6}><EntityConsumingComponentsCard /></Grid>
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/definition" title="Definição">
      <Grid container spacing={3}>
        <Grid item xs={12}><EntityApiDefinitionCard /></Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
